export default "__VITE_ASSET__69fe0417__"